// ===== HISTÓRICO =====
// renderSnapshots/renderAuditoria e helpers exclusivos da página movidos para page-historico.js
function faturamentoMedioMensalHistorico(meses){
  meses=meses||6;
  var lancs=CACHE.lancamentos||DB.get('lancamentos')||[];
  var hoje=new Date(),porMes={};
  for(var i=1;i<=meses;i++){
    var d=new Date(hoje.getFullYear(),hoje.getMonth()-i,1);
    var mes=d.toISOString().slice(0,7);
    var total=lancs.filter(function(l){return l.tipo==='entrada'&&(l.data||'').startsWith(mes);}).reduce(function(s,l){return s+(parseFloat(l.valor)||0);},0);
    if(total>0)porMes[mes]=total;
  }
  var vals=Object.values(porMes);
  if(!vals.length)return null;
  return {media:Math.round(vals.reduce(function(s,v){return s+v;},0)/vals.length),meses:vals.length};
}
function renderCfgHistorico(){
  // Faturamento
  var fatEl=document.getElementById('cfg-fat-historico');
  if(fatEl){
    var fh=faturamentoMedioMensalHistorico(6);
    if(fh){
      fatEl.innerHTML='Histórico dos últimos '+fh.meses+' mese(s) c/ receita: <strong>'+fmt(fh.media)+'</strong>'
        +' <a href="#" style="color:var(--accent)" onclick="event.preventDefault();document.getElementById(\'cfg-fat\').value='+fh.media+';updateCfgPreview()">← usar este</a>';
    } else {
      fatEl.textContent='Sem lançamentos de receita registrados para calcular.';
    }
  }
  // Aproveitamento
  var aprovEl=document.getElementById('cfg-aprov-historico');
  if(aprovEl){
    var ah=aproveitamentoHistoricoFabrica();
    var pct=(ah.fator*100).toFixed(1);
    var fonteMap={historico_cortado:'média de '+ah.n+' plano(s) cortado(s)',planos_estimado:'estimado de '+ah.n+' plano(s) em aberto'};
    if(ah.fonte==='config'){
      aprovEl.textContent='Sem planos de corte salvos. Configure manualmente.';
    } else {
      aprovEl.innerHTML='Histórico de planos de corte: <strong>'+pct+'%</strong> ('+fonteMap[ah.fonte]+')'
        +' <a href="#" style="color:var(--accent)" onclick="event.preventDefault();document.getElementById(\'cfg-aproveitamento\').value='+pct+'">← usar este</a>';
    }
  }
}
